import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const AdvancePurchaseApi = createApi({
    reducerPath: "AdvancePurchaseApi",
    baseQuery: authBaseQuery,
    endpoints: (builder) => ({
        // Get advanced payment overview
        getAdvancedPaymentOverview: builder.query({
            query: () => "/purchase/advanced_payment_overview",
            transformResponse: (response) => response?.data,
        }),

        // Get advanced payment overview details
        getAdvancedPaymentOverviewDetails: builder.query({
            query: (searchQuery) => `/purchase/advanced_payment_overview_details?type=${searchQuery}`,
            transformResponse: (response) => response?.data,
        }),

        // Get advanced payment usage slot
        getAdvancedPaymentUsageSlot: builder.query({
            query: (searchQuery) => `/purchase/advanced_payment_usage_slot?type=${searchQuery}`,
            transformResponse: (response) => response?.data,
        }),

        // Get advanced payment new pages details
        getAdvancedPaymentNewPagesDetails: builder.query({
            query: (searchQuery) => `/purchase/advanced_payment_new_pages_details?type=${searchQuery}`,
            transformResponse: (response) => response?.data,
        }),
        // getAdvancePaymentsByPageAndVendor: builder.query({
        //     query: (pageName) => `purchase/advanced_payment?page_id=${pageName}`,
        //     transformResponse: (response) => response?.data,
        // }),
        getAdvancePaymentsByPageAndVendor: builder.query({
            query: ({ vendorID, pageID }) => {
                let queryParams = [];

                if (vendorID) {
                    queryParams.push(`vendor_obj_id=${vendorID}`);
                }
                if (pageID) {
                    queryParams.push(`page_id=${pageID}`);
                }

                const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

                return `purchase/advanced_payment${queryString}`;
            },
            transformResponse: (response) => response?.data,
        }),

        getSettleAdvanceByPageAndVendor: builder.query({
            query: ({ vendorID, pageID }) => {
                let queryParams = [];

                if (vendorID) {
                    queryParams.push(`vendor_obj_id=${vendorID}`);
                }
                if (pageID) {
                    queryParams.push(`page_id=${pageID}`);
                }

                const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

                return `purchase/advanced_payment${queryString}&advanced_payment_status=settled`;
            },
            transformResponse: (response) => response?.data,
        }),
        getAdvancedVendorHistory: builder.query({
            query: ({ vendorID, pageID }) => {
                let queryParams = [];

                if (vendorID) {
                    queryParams.push(`vendor_obj_id=${vendorID}`);
                }
                if (pageID) {
                    queryParams.push(`page_id=${pageID}`);
                }

                const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

                return `purchase/advanced_payment_vendor_history${queryString}`;
            },
            transformResponse: (response) => response?.data,
        }),

    }),
});

export const {
    useGetAdvancedPaymentOverviewQuery,
    useGetAdvancedPaymentOverviewDetailsQuery,
    useGetAdvancedPaymentUsageSlotQuery,
    useGetAdvancedPaymentNewPagesDetailsQuery,
    useGetAdvancePaymentsByPageAndVendorQuery,
    useGetSettleAdvanceByPageAndVendorQuery,
    useGetAdvancedVendorHistoryQuery,
} = AdvancePurchaseApi;

export default AdvancePurchaseApi;
